import React, { useState } from 'react'
import {
  Row,
  Col,
  Card,
  Form,
  Button,
  InputGroup,
  FormControl,
  DropdownButton,
  Dropdown,
  Table,
  FormSelect
} from 'react-bootstrap'
import './findUserFull.sass'

import avatar1 from '../../assets/images/user/avatar-1.jpg'
import avatar2 from '../../assets/images/user/avatar-2.jpg'
import avatar3 from '../../assets/images/user/avatar-3.jpg'

import { CONFIG } from '../../config/constant'
import { BASE } from '../../basedata/constants'

import { useForm } from 'react-hook-form'

export function FindUser() {
  const [userList, setUserList] = useState([])

  const [userSearch, setUserSearch] = useState({
    identifier: '',
    type: 'externalId'
  })

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
    clearErrors,
    getValues
  } = useForm()

  const onSubmit = (data: any) => {
    fetch(`${BASE.api.base_url}${BASE.api.find_user_with_biometry}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: CONFIG.API_KEY
      },
      body: JSON.stringify({
        userId: data.identifier,
        userSearchType: 'externalId'
      })
    })
      .then((resg) => resg.json())
      .then((response) => {
        console.log('oieee')
        setUserList(response)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const removeBiometry = (userId: any, userData: any) => {
    if (!confirm('Tem certeza?')) {
      return false
    }
    fetch(`${BASE.api.base_url}${BASE.api.remove_biometry}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: CONFIG.API_KEY
      },
      body: JSON.stringify({
        user: userId
      })
    })
      .then((resg) => resg.json())
      .then((response) => {
        onSubmit({
          type: userData[0],
          identifier: userData[1]
        })
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const fixName = (userToken: any, userName: any) => {
    if (!confirm('Tem certeza?')) {
      return false
    }
    fetch(`${BASE.api_user.base_url}${BASE.api_user.user_edit}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: CONFIG.API_KEY
      },
      body: JSON.stringify({
        id: userToken,
        name: `${userName}_`
      })
    })
      .then((resg) => resg.json())
      .then((response) => {
        alert('Usuário Alterado.')
      })
      .catch((error) => {
        console.log(error)
      })
  }

  return (
    <Card>
      <Card.Header>
        <Card.Title as="h5" className="search-header">
          Pesquisar
        </Card.Title>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            {/* <Col className="mb-2" lg={12} xl={2}>
              <select
                className="form-control"
                {...register('type', { required: true })}
              >
                <option value="externalId">Matrícula</option>
                <option value="lastName">Nome Completo</option>
                <option value="document">Documento (CPF)</option>
              </select>
            </Col> */}
            <Col className="mb-2" lg={12} xl={8}>
              <input
                placeholder="Matrícula"
                className="form-control"
                {...register('identifier', { required: true })}
              />
            </Col>
            <Col className="mb-2" lg={12} xl={4}>
              <input
                className="btn w-100 btn-primary"
                type="submit"
                value="Pesquisar"
                onClick={() => clearErrors()}
              />
            </Col>
          </Row>
        </form>
      </Card.Header>

      <Card.Body>
        <Table responsive>
          <tbody>
            {userList &&
              userList.map((user: any) => (
                <tr key={user.hikiId} className="">
                  <td colSpan={1}>
                    {/* <img
                    className="rounded-circle"
                    style={{ width: '40px' }}
                    src={
                      user.userAvatar
                        ? `${BASE.api.base_url}/biometricImages/${user.userAvatar}`
                        : avatar1
                    }
                    alt="activity-user"
                  /> */}
                    <img
                      className="rounded-circle"
                      style={{ width: '40px' }}
                      src={avatar2}
                    />
                  </td>
                  <td colSpan={4}>
                    <h6 className="mb-1">{user.name}</h6>
                    <p className="m-0">Mat. {user.externalId}</p>
                  </td>
                  <td>
                    <a
                      href="#"
                      className={`label user-trigger btn-ghost f-12`}
                      onClick={() => fixName(user.token, user.name)}
                    >
                      Homônimo
                    </a>
                  </td>
                  <td colSpan={2}>
                    <a
                      href="#"
                      className={`label user-trigger btn-ghost f-12`}
                      onClick={() =>
                        removeBiometry(
                          user.token,
                          getValues(['type', 'identifier'])
                        )
                      }
                    >
                      Refazer Biometria
                    </a>
                    {/* <a
                    href="#"
                    className={`label ${
                      user.access_code ? '' : 'user-not-found'
                    } user-trigger text-white f-12`}
                  >
                    Multiclubes
                  </a> */}
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  )
}
